// import { Location} from 'react-router';
import { Modal } from "react-bootstrap";
import { ModalBatchPicker } from "../modal-batch-picker";
import { ModalAttendanceTimePicker } from "../modal-attendance-time-picker";
import { User, Batch, ActivitySlotTemplate } from "../../_models";
import AttendanceService from "./../../_services/AttendanceService";
import { StudentAttendanceDetail } from "../../_models/student-attendance-detail";
import { Student } from "../../_models/student";
import { TimetableTemplate } from "../../_models/timetable-template";
import TimetableService from "./../../_services/TimeTableService";
import BatchService from "../../_services/BatchService";
import StudentService from "./../../_services/StudentService";
import ApiService from "./../../_services/ApiService";
import { first, retry } from "rxjs/operators";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFingerprint, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Router } from "react-router-dom";
import React from "react";
import UserService from "../../_services/UserService";
import AuthenticationService from "../../_services/AuthenticationService";
import DialogService from "../../_services/DialogService";
import Switch from "react-switch";
import "../../assets/css/bootstrap.css";
import { timeTable } from "../../constants/routes";
import Module from "module";
import { DbService } from "../../_services/DbService";
import { getAttendanceConfig } from "../../_config/attendance-config";
import { RouteComponentProps } from "react-router-dom";
import myAxios from "../../_services/axiositeachWrapper";
import Config from "../../_config/config";
import { ConfirmDialog } from "../../_components/confirm-dialog/confirmDialog";
import { AlertDialog } from "../../_components/alert-dialog/AlertDialog";
import "./attendance.css";
import ImagePreview from "../../_components/image-preview/image-preview.component";
import { ReactComponent as ShowImageIcon } from "../../assets/icons/images-solid.svg";
import { ReactComponent as CameraIcon } from "../../assets/icons/camera-solid.svg";
import { AppPropertiesContext } from "../../contexts/app-properties.context";

interface MatchParams {
  batchIds: string | undefined;
}

interface MyProps extends RouteComponentProps<MatchParams> {
  my_modal_title: string;
  my_modal_content: string;
}
type MyState = {
  batches: Batch[];
  batchPickerSlotFlag: boolean;
  selectedBatch: Batch;
  ATTENDANCE_CONFIG: any;
  startTimePickerFlag: boolean;
  endTimePickerFlag: boolean;
  attendanceDetails: any;
  topics: any;
  selectedTopic: any;
  timetableTemplates: TimetableTemplate[];
  studentAttendanceDetails: StudentAttendanceDetail[];
  alertTitle: string;
  alertMessage: string;
  showAlert: boolean;
  confirmMessage: string;
  confirmTitle: string;
  btnOkText: string;
  btnCancelText: string;
  confirmSize: string;
  confirmId: number;
  selectedScheduleActivitySlot: any;
  showConfirm: boolean;
  attendanceImages: any;
  displayImagePreview: Boolean;
  selectedBatches: Batch[];
  instructors: { id: number; name: string }[];
  selectedInstructorId: number;
  loadingStudents: boolean;
  savingAttendance: boolean;
  attendanceAlreadyTaken: boolean;
};

export class Attendance extends React.Component<MyProps, MyState> {
  state: MyState = {
    batches: [],
    batchPickerSlotFlag: true,
    selectedBatch: null,
    ATTENDANCE_CONFIG: {},
    startTimePickerFlag: false,
    endTimePickerFlag: false,
    attendanceDetails: {},
    topics: null,
    selectedTopic: null,
    timetableTemplates: [],
    studentAttendanceDetails: [],
    alertMessage: "",
    showAlert: false,
    alertTitle: "ALERT",
    showConfirm: false,
    confirmMessage: "",
    confirmTitle: "CONFIRM",
    btnOkText: "OK",
    btnCancelText: "CANCEL",
    confirmSize: "lg",
    confirmId: -1,
    selectedScheduleActivitySlot: {},
    attendanceImages: [],
    displayImagePreview: false,
    selectedBatches: null,
    instructors: [],
    selectedInstructorId: -1,
    loadingStudents: false,
    savingAttendance: false,
    attendanceAlreadyTaken: false,
  };

  currentUser: User;
  activitySlotTemplates: ActivitySlotTemplate[] = [];
  closeResult: string;
  ACTIVITYSLOT_ID: number = -1;
  activitySlotStudents: any = []; //For saving already attendnace taken students data for update
  attendanceImages: any;
  errorMessages: any = {};
  students: Student[] = [];
  bioMetricStudentAttendanceDetailMap = new Map();
  activitySlotId: any = 0;
  timetableservice: TimetableService = new TimetableService();
  studentservice: StudentService = new StudentService();
  batchService: BatchService = new BatchService();
  dbservice: DbService = new DbService();

  constructor(props: MyProps) {
    super(props);
    this.getSelectedBatch = this.getSelectedBatch.bind(this);
    this.closeBatchPicker = this.closeBatchPicker.bind(this);
    this.closeStartTimePicker = this.closeStartTimePicker.bind(this);
    this.getStartTime = this.getStartTime.bind(this);
    this.closeEndTimePicker = this.closeEndTimePicker.bind(this);
    this.getEndTime = this.getEndTime.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    // this.currentUser = this.authenticationService.currentUserValue;
  }

  static contextType = AppPropertiesContext;
  context!: React.ContextType<typeof AppPropertiesContext>;

  componentDidMount() {
    const { isUsingCacheMethod } = this.context;

    if (isUsingCacheMethod()) {
      let stateHolder: any = this.props.location.state;
      if (stateHolder?.selectedBatch) {
        console.log("!!!!!this is running!!!");
        console.log("Init Data : <<>> :" + localStorage.getItem("initData"));
        this.setState({
          ATTENDANCE_CONFIG: getAttendanceConfig(),
        });
        this.dbservice.connect().then(() => {
          this.setState({ batchPickerSlotFlag: false }, () => {
            this.getSelectedBatch({ batch: stateHolder.selectedBatch });
            this.setState(
              {
                attendanceImages: [...stateHolder.attendanceImages],
                studentAttendanceDetails: stateHolder.studentAttendanceDetails,
              },
              () => {
                console.log(this.state.attendanceImages);
              }
            );
          });
          // this.displayBatchPicker();
        });
      } else {
        console.log("are you running?");
        console.log("Init Data : <<>> :" + localStorage.getItem("initData"));
        this.setState({
          ATTENDANCE_CONFIG: getAttendanceConfig(),
        });
        this.dbservice.connect().then(() => {
          this.displayBatchPicker();
        });
      }
    } else {
      this.setState({
        ATTENDANCE_CONFIG: getAttendanceConfig(),
      });

      const searchParams = new URLSearchParams(this.props.location.search);
      const templateSlotIdParam = searchParams.get('templateSlotId');
      if (templateSlotIdParam) {
        (this as any).targetTemplateSlotId = parseInt(templateSlotIdParam);
      }
      const instructorIdParam = searchParams.get('instructorId');
      if (instructorIdParam) {
        (this as any).urlInstructorId = parseInt(instructorIdParam);
      }
      const instructorNameParam = searchParams.get('instructorName');
      if (instructorNameParam) {
        (this as any).urlInstructorName = instructorNameParam;
      }
      const batchNamesParam = searchParams.get('batchNames');
      if (batchNamesParam) {
        (this as any).urlBatchNames = batchNamesParam.split(',');
      }

      const batches = this.props.match.params.batchIds;

      if (batches) {
        let batchArr = batches.split(",").filter((id, idx, arr) => arr.indexOf(id) === idx);
        console.log(batchArr, "here");
        this.closeBatchPicker();

        return this.fetchMultipleBatchData(batchArr);
      }

      this.fetchBatchData();
    }
  }

  fetchMultipleBatchData = async (batchArr: string[]) => {
    const currentUser = AuthenticationService?.currentUserValue;
    const instructorId = (this as any).urlInstructorId || currentUser?.instructorId;
    try {
      const responseDetails = await ApiService.syncBatches(instructorId);
      const batches = responseDetails.data?.data;
      this.setState({
        batches,
      });

      console.log(batches);

      const selectedBatches = batches
        .filter((batch) => batchArr.includes(batch.id.toString()))
        .filter((batch, idx, arr) => arr.findIndex((b) => b.id === batch.id) === idx);

      const foundBatchIds = selectedBatches.map((b: any) => b.id.toString());
      const missingBatchIds = batchArr.filter((id) => !foundBatchIds.includes(id));

      if (missingBatchIds.length > 0) {
        const instructorName = (this as any).urlInstructorName || 'this instructor';
        const urlBatchNames: string[] = (this as any).urlBatchNames || [];
        const missingLabels = missingBatchIds.map((id, idx) => {
          const batchIndex = batchArr.indexOf(id);
          const name = urlBatchNames[batchIndex];
          return name ? `${name} (ID: ${id})` : `Batch ID: ${id}`;
        });
        this.setState({
          showAlert: true,
          alertTitle: 'Batch-Instructor Mapping Missing',
          alertMessage:
            `The following batches are assigned to this timetable slot but are not mapped to ` +
            `instructor "${instructorName}" in the Instructor-Batch mapping:\n\n` +
            `${missingLabels.join(', ')}\n\n` +
            `Please go to the Instructor-Batch mapping screen and assign these batches to the instructor.`,
        });
      }

      this.setState({
        selectedBatches,
        selectedBatch: selectedBatches.length > 0 ? selectedBatches[0] : null
      }, () => {
        this.initAttendanceDetails();
      });
    } catch (err) {
      console.log(err);
    }
  };

  fetchBatchData = async () => {
    const currentUser = AuthenticationService?.currentUserValue;
    const userTypeId = currentUser?.userTypeId;

    try {
      // Use new centre-aware endpoint that handles both instructors and non-instructors
      const response: any = await myAxios.get(`${Config.nodeSiteUrl}v1/batches/by-user`);
      const batches = response.data?.data || [];

      if (batches.length === 0) {
        // Show helpful message based on user type
        const message = userTypeId === 4
          ? "No batches found. You may not be assigned to any batches."
          : "No batches found. You may not have access to any centres.";
        console.warn(message);
      }

      this.setState({ batches });
      this.openBatchPicker();
    } catch (err) {
      console.error("Failed to fetch batches:", err);
    }
  };

  getSelectedBatch(result: any) {
    this.setState({ selectedBatch: result.batch });
    setTimeout(() => {
      console.log(result.batch);
      console.log("Closed with:" + JSON.stringify(this.state?.selectedBatch));
      console.log("Closed with:<<>>" + this.state.selectedBatch?.name);
      this.initAttendanceDetails();
    }, 0);
  }

  displayBatchPicker() {
    this.batchService.getBatches().then(
      (data) => {
        console.log(data);
        this.setState({ batches: data });
        console.log(data);
      },
      (error) => {
        console.log(error);
      }
    );
    console.log("in displayBatchPicker");
    this.openBatchPicker();
  }

  openBatchPicker = () => {
    this.setState({ batchPickerSlotFlag: true });
  };

  initAttendanceDetails() {
    console.log("In initAttendanceDetails()...");
    console.log(this.state.selectedBatch);

    this.setState({ timetableTemplates: [] });
    this.activitySlotTemplates = [];
    this.students = [];
    let today = new Date();
    console.log(today, "here---");
    let dd: any = today.getDate();
    let mm: any = today.getMonth() + 1;
    let yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }
    if (mm < 10) {
      mm = "0" + mm;
    }
    let currentUser = JSON.parse(localStorage.getItem("currentUser"));
    //this.todayDate = dd+'/'+mm+'/'+yyyy;
    this.setState({
      attendanceDetails: {
        slotDate: dd + "/" + mm + "/" + yyyy,
        batchId: -1,
        batchName: null,
        timeTableId: -100,
        activitySlotTempalteId: -1,
        startTime: -1,
        endTime: -1,
        minutesLate: "",
        topicId: -1,
        topicName: "",
        instructorId: (this as any).urlInstructorId || currentUser?.instructorId,
        syncStatus: 0,
        activitySlotId: this.activitySlotId,
        timerMinutesInterval: "0,15,30,45",
      },
    });
    this.errorMessages = {
      batchId: "",
      timeTableId: "",
      activitySlotTempalteId: "",
      startTime: "",
      endTime: "",
      minutesLate: "",
      topicId: "",
    };
    this.setState((prevState) => ({
      attendanceDetails: {
        ...prevState.attendanceDetails,
        startTime: this.state.ATTENDANCE_CONFIG.startTimeForAttendance,
      },
    }));
    this.setState((prevState) => ({
      attendanceDetails: {
        ...prevState.attendanceDetails,
        endTime: this.state.ATTENDANCE_CONFIG.endTimeForAttendance,
      },
    }));
    if (this.state.ATTENDANCE_CONFIG.timerMinutesInterval) {
      this.setState((prevState) => ({
        attendanceDetails: {
          ...prevState.attendanceDetails,
          timerMinutesInterval:
            this.state.ATTENDANCE_CONFIG.timerMinutesInterval,
        },
      }));
    }

    if (this.state.selectedBatches) {
      this.setState((prevState) => ({
        attendanceDetails: {
          ...prevState.attendanceDetails,
          batchIds: this.state.selectedBatches.map(
            (selectedBatch) => selectedBatch.id
          ),
          batchName: this.state.selectedBatches.map(
            (selectedBatch) => selectedBatch.name
          ),
        },
      }));

      this.fetchMultipleTimeTable();
      this.getMultipleBioMetricStudentAttendance();

      return;
    }

    if (this.state.selectedBatch) {
      this.setState((prevState) => ({
        attendanceDetails: {
          ...prevState.attendanceDetails,
          batchId: this.state.selectedBatch.id,
        },
      }));
      this.setState((prevState) => ({
        attendanceDetails: {
          ...prevState.attendanceDetails,
          batchName: this.state.selectedBatch.name,
        },
      }));

      this.getTimeTables();
      this.getBioMetricStudentAttendance();
    }
    //console.log("In initAttendanceDetails(), activitySlotTemplates :: "+JSON.stringify(this.attendanceDetails));
  }

  private getDismissReason(reason: any): string {
    // if (reason === ModalDismissReasons.ESC) {
    //   return 'by pressing ESC';
    // } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    //   return 'by clicking on a backdrop';
    // } else {
    //   return  `with: ${reason}`;
    // }
    return "NO";
  }

  private getTimeTables = () => {
    console.log("In getTimeTables()...");
    const { isUsingCacheMethod } = this.context;
    if (isUsingCacheMethod()) {
      this.timetableservice
        .getTimetablesForBatch(this.state.selectedBatch.id)
        .then(
          (timetableTemplates) => {
            this.setState({ timetableTemplates: timetableTemplates });
            console.log("Timetables: " + JSON.stringify(timetableTemplates));
            if (this.state.timetableTemplates.length > 0) {
              this.getActivitySlotTemplatesForTimetable();
            } else {
              //this.getInstructorBatchTopics();
              this.initTopics();
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      this.fetchTimeTable();
    }
  };

  fetchMultipleTimeTable = async () => {
    const currentUser = AuthenticationService?.currentUserValue;
    const instructorId = (this as any).urlInstructorId || currentUser?.instructorId;
    try {
      const timeTableDetails = await Promise.all(
        this.state.selectedBatches.map((selectedBatch) =>
          ApiService.syncTimeTables(instructorId, [selectedBatch.id])
        )
      );
      console.log(timeTableDetails, "here");

      const timetableTemplates = timeTableDetails.reduce(
        (accumulator, currentValue) => [
          ...accumulator,
          ...currentValue.data?.data,
        ],
        []
      );

      this.setState({ timetableTemplates }, () => {
        this.buildInstructorList();
        if (this.state.timetableTemplates.length > 0) {
          //! need to look for this function
          console.log(this.state.timetableTemplates);
          this.getActivitySlotTemplatesForTimetable();
        } else {
          console.log(this.state.timetableTemplates);
          //this.getInstructorBatchTopics();
          this.initMultipleBatchTopics();
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  fetchTimeTable = async () => {
    const currentUser = AuthenticationService?.currentUserValue;
    const instructorId = (this as any).urlInstructorId || currentUser?.instructorId;
    try {
      const timeTableDetails = await ApiService.syncTimeTables(instructorId, [
        this.state.selectedBatch.id,
      ]);
      console.log(timeTableDetails, "here");
      const timetableTemplates = timeTableDetails.data?.data;

      this.setState({ timetableTemplates }, () => {
        this.buildInstructorList();
        if (this.state.timetableTemplates.length > 0) {
          //! need to look for this function
          console.log(this.state.timetableTemplates);
          this.getActivitySlotTemplatesForTimetable();
        } else {
          console.log(this.state.timetableTemplates);
          //this.getInstructorBatchTopics();
          this.initTopics();
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  buildInstructorList() {
    const instructorMap = new Map<number, string>();
    this.state.timetableTemplates?.forEach((template: any) => {
      template.activitySlotTemplates?.forEach((slot: any) => {
        if (slot.instructorId && !instructorMap.has(slot.instructorId)) {
          instructorMap.set(slot.instructorId, slot.instructorName || `Instructor ${slot.instructorId}`);
        }
      });
    });

    // Include the URL instructor if provided and not already in list
    if ((this as any).urlInstructorId && (this as any).urlInstructorName) {
      if (!instructorMap.has((this as any).urlInstructorId)) {
        instructorMap.set((this as any).urlInstructorId, (this as any).urlInstructorName);
      }
    }

    const instructors = Array.from(instructorMap.entries()).map(([id, name]) => ({ id, name }));

    // Determine selected instructor: URL param > current attendanceDetails > first in list
    let selectedInstructorId = this.state.attendanceDetails.instructorId;
    if (!instructorMap.has(selectedInstructorId) && instructors.length > 0) {
      selectedInstructorId = instructors[0].id;
    }

    this.setState({
      instructors,
      selectedInstructorId,
    });
  }

  onInstructorChange(instructorId: number) {
    this.setState({
      selectedInstructorId: instructorId,
    });
    this.setState((prevState) => ({
      attendanceDetails: {
        ...prevState.attendanceDetails,
        instructorId: instructorId,
      },
    }), () => {
      this.getActivitySlotTemplatesForTimetable();
    });
  }

  getActivitySlotTemplatesForTimetable() {
    console.log("In getActivitySlotTemplatesForTimetable();");
    this.activitySlotTemplates = [];
    if (
      this.state.timetableTemplates &&
      this.state.timetableTemplates.length > 0
    ) {
      let activitySlotTemplates;
      this.state.timetableTemplates?.forEach((template: any, index) => {
        if (template.activitySlotTemplates?.length > 0) {
          activitySlotTemplates =
            this.state.timetableTemplates[index].activitySlotTemplates;
          this.setState((prevState) => ({
            attendanceDetails: {
              ...prevState.attendanceDetails,
              timeTableId: this.state.timetableTemplates[index].id,
            },
          }));
          return false;
        }
      });
      console.log(
        "activitySlotTemplates : " + JSON.stringify(activitySlotTemplates)
      );
      let _slotDate = this.state.attendanceDetails.slotDate;
      let _instructorId = this.state.attendanceDetails.instructorId;
      let _activitySlotTemplates: ActivitySlotTemplate[] = [];
      console.log(
        "activitySlotTemplates slot date: " +
          _slotDate +
          " <<>> InstructorId : " +
          _instructorId
      );

      // If a specific templateSlotId was requested, find that exact slot first
      if ((this as any).targetTemplateSlotId) {
        let targetSlot: any = null;
        let targetTimetableId: any = null;
        this.state.timetableTemplates?.forEach((template: any) => {
          template.activitySlotTemplates?.forEach((slot: any) => {
            if (slot.id === (this as any).targetTemplateSlotId) {
              targetSlot = slot;
              targetTimetableId = template.id;
            }
          });
        });
        if (targetSlot) {
          _activitySlotTemplates = [targetSlot];
          this.setState((prevState) => ({
            attendanceDetails: {
              ...prevState.attendanceDetails,
              slotDate: targetSlot.date,
              timeTableId: targetTimetableId,
            },
          }));
        }
      }

      // Fall back to filtering by today's date and instructor if no specific slot was found
      if (_activitySlotTemplates.length === 0) {
        activitySlotTemplates?.forEach(function (activitySlotTemplate) {
          if (
            activitySlotTemplate.date === _slotDate &&
            activitySlotTemplate.instructorId == _instructorId
          ) {
            console.log("******");
            _activitySlotTemplates.push(activitySlotTemplate);
          }
        });
      }
      console.log(
        "activitySlotTemplates : " + JSON.stringify(_activitySlotTemplates)
      );
      this.activitySlotTemplates = _activitySlotTemplates;
      if (this.activitySlotTemplates.length > 0) {
        this.setState((prevState) => ({
          attendanceDetails: {
            ...prevState.attendanceDetails,
            activitySlotTempalteId: this.activitySlotTemplates[0].id,
          },
        }));
        //displaying only Activityslot Topic.
        this.setState(
          {
            selectedTopic: {
              id: this.activitySlotTemplates[0].topicId,
              name: this.activitySlotTemplates[0].topicName,
            },
          },
          () => {
            this.setState(
              {
                topics: [
                  {
                    id: this.activitySlotTemplates[0].topicId,
                    name: this.activitySlotTemplates[0].topicName,
                  },
                ],
              },
              () => {
                this.setState((prevState) => ({
                  attendanceDetails: {
                    ...prevState.attendanceDetails,
                    topicId: this.activitySlotTemplates[0].id,
                    topicName: this.state.selectedTopic.name,
                    startTime: this.activitySlotTemplates[0].startTime,
                    endTime: this.activitySlotTemplates[0].endTime,
                  },
                }));
              }
            );
          }
        );
        //console.log("selectedTopic :: "+JSON.stringify(this.selectedTopic));
        //console.log("activitySlotTemplates :: "+JSON.stringify(this.attendanceDetails));
      } else {
        this.setState((prevState) => ({
          attendanceDetails: {
            ...prevState.attendanceDetails,
            timeTableId: -100,
          },
        }));
        //Setting Non-Standard className default if no activitySlotTemplates (classes) found for timetable.
        this.initTopics();
      }
    }
  }

  getStartTime(startTime) {
    this.setState((prevState) => ({
      attendanceDetails: {
        ...prevState.attendanceDetails,
        startTime: startTime,
      },
    }));
  }

  displayStartTimePicker() {
    if (this.state.attendanceDetails.activitySlotTempalteId <= 0) {
      // const modalRef = this.modalService.open(ModalAttendanceTimePickerComponent);
      // modalRef.componentInstance.my_modal_title = 'Attendance Time Picker';
      // //modalRef.componentInstance.my_modal_content = 'Instructor batches..';
      // //modalRef.componentInstance.startHour = this.ATTENDANCE_CONFIG.startHour;
      // //modalRef.componentInstance.startHourMinute = this.ATTENDANCE_CONFIG.startHourMinute;
      // modalRef.componentInstance.minuteStep = 5;
      // modalRef.result.then((result) => {
      //   this.attendanceDetails.startTime = result.hour+":"+result.minute;
      //   console.log('Start Time:'+ result.hour+":"+result.minute);
      // }, (reason) => {
      //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      //   console.log(this.closeResult);
      // });
      this.setState({ startTimePickerFlag: true });
    }
  }

  getEndTime(endTime) {
    this.setState((prevState) => ({
      attendanceDetails: { ...prevState.attendanceDetails, endTime: endTime },
    }));
  }

  closeStartTimePicker() {
    this.setState({ startTimePickerFlag: false });
  }

  closeEndTimePicker() {
    this.setState({ endTimePickerFlag: false });
  }

  displayEndTimePicker() {
    if (this.state.attendanceDetails.activitySlotTempalteId <= 0) {
      // const modalRef = this.modalService.open(ModalAttendanceTimePicker);
      // modalRef.componentInstance.my_modal_title = 'Attendance Time Picker';
      // //modalRef.componentInstance.my_modal_content = 'Instructor batches..';
      // //modalRef.componentInstance.startHour = this.ATTENDANCE_CONFIG.startHour;
      // //modalRef.componentInstance.startHourMinute = this.ATTENDANCE_CONFIG.startHourMinute;
      // modalRef.componentInstance.minuteStep = 5;
      // modalRef.result.then((result) => {
      //   this.attendanceDetails.endTime = result.hour+":"+result.minute;
      //   console.log('End Time:'+ result.hour+":"+result.minute);
      // }, (reason) => {
      //   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      //   console.log(this.closeResult);
      // });
      this.setState({ endTimePickerFlag: true });
    }
  }

  getMultipleBioMetricStudentAttendance = async () => {
    try {
      const respData = await Promise.all(
        this.state.selectedBatches.map((selectedBatch) =>
          ApiService.getBioMetricStudentAttendance(selectedBatch.id)
        )
      );
      console.log(
        "getBioMetricStudentAttendance(), Response : " +
          JSON.stringify(respData)
      );
      if (respData[0].data?.status == 1) {
        let biometricAttendanceDetails = respData.reduce(
          (accumulator, currentValue) => [
            ...accumulator,
            ...currentValue.data?.data,
          ],
          []
        );

        // respData.data?.data;

        if (biometricAttendanceDetails.length > 0) {
          biometricAttendanceDetails.map((biometricAttendanceDetail) => {
            this.bioMetricStudentAttendanceDetailMap.set(
              biometricAttendanceDetail.enrollmentId,
              biometricAttendanceDetail.attendanceStatus
            );
          });
        }
        this.addBioMetricAttendanceStatus();
      } else {
        console.log(respData[0].data.message);
        //alert(respData.message);
      }
    } catch (error) {
      console.log("Unable to get data Network Error: " + error);
    }

    //console.log("In getBioMetricStudentAttendance() batchId :"+this.selectedBatch.id+" , instructorId :"+this.currentUser.instructorId);
  };

  getBioMetricStudentAttendance() {
    //console.log("In getBioMetricStudentAttendance() batchId :"+this.selectedBatch.id+" , instructorId :"+this.currentUser.instructorId);
    ApiService.getBioMetricStudentAttendance(this.state.selectedBatch.id).then(
      (respData) => {
        console.log(
          "getBioMetricStudentAttendance(), Response : " +
            JSON.stringify(respData.data)
        );
        if (respData.data?.status == 1) {
          let biometricAttendanceDetails = respData.data?.data;
          if (biometricAttendanceDetails.length > 0) {
            biometricAttendanceDetails.map((biometricAttendanceDetail) => {
              this.bioMetricStudentAttendanceDetailMap.set(
                biometricAttendanceDetail.enrollmentId,
                biometricAttendanceDetail.attendanceStatus
              );
            });
          }
          this.addBioMetricAttendanceStatus();
        } else {
          console.log(respData.data.message);
          //alert(respData.message);
        }
      },
      (error) => {
        //this.alertService.error(error);
        console.log("Unable to get data Network Error: " + error);
        //alert(error);
      }
    );
  }

  addMultipleBatchBioMetricAttendanceStatus() {
    console.log("In addBioMetricAttendanceStatus()... ");
    if (this.bioMetricStudentAttendanceDetailMap.size > 0) {
      if (this.state.studentAttendanceDetails.length > 0) {
        const batches = this.state.studentAttendanceDetails;
        console.log("here");
        batches.forEach((studentAttendanceDetails, i) => {
          let _studentAttendanceDetails: any = studentAttendanceDetails;
          _studentAttendanceDetails.forEach((_studentAttendanceDetail) => {
            let _bioMetricAttendnace = "";
            if (
              this.bioMetricStudentAttendanceDetailMap.has(
                _studentAttendanceDetail.student.id
              )
            ) {
              _bioMetricAttendnace =
                this.bioMetricStudentAttendanceDetailMap.get(
                  _studentAttendanceDetail.student.id
                );
            }
            _studentAttendanceDetail.bioMetricAttendnace = _bioMetricAttendnace;
          });
          batches[i] = _studentAttendanceDetails;
        });

        this.setState({ studentAttendanceDetails: batches });
      }
    }
  }
  addBioMetricAttendanceStatus() {
    console.log("In addBioMetricAttendanceStatus()... ");
    if (this.bioMetricStudentAttendanceDetailMap.size > 0) {
      if (this.state.studentAttendanceDetails.length > 0) {
        let _studentAttendanceDetails: any =
          this.state.studentAttendanceDetails;
        _studentAttendanceDetails.forEach((_studentAttendanceDetail) => {
          let _bioMetricAttendnace = "";
          if (
            this.bioMetricStudentAttendanceDetailMap.has(
              _studentAttendanceDetail.student.id
            )
          ) {
            _bioMetricAttendnace = this.bioMetricStudentAttendanceDetailMap.get(
              _studentAttendanceDetail.student.id
            );
          }
          _studentAttendanceDetail.bioMetricAttendnace = _bioMetricAttendnace;
        });
        this.setState({ studentAttendanceDetails: _studentAttendanceDetails });
      }
    }
  }

  onSelectChange(type: any, selectedClassId: any = null) {
    console.log("Change Event fired. TYPE: " + type);
    this.students = [];
    if (type === "timetable") {
      if (this.state.attendanceDetails.timeTableId == -100) {
        //Non Standard
        console.log("Change Event fired. TYPE: -100 " + type);
        this.setState((prevState) => ({
          attendanceDetails: {
            ...prevState.attendanceDetails,
            timeTableId: -100,
            activitySlotTempalteId: -1,
            startTime: this.state.ATTENDANCE_CONFIG.startTimeForAttendance,
            endTime: this.state.ATTENDANCE_CONFIG.endTimeForAttendance,
          },
        }));
        this.activitySlotTemplates = [];
        this.initTopics();
      } else {
        this.getActivitySlotTemplatesForTimetable();
      }
    } else if (type === "class") {
      this.setState(
        (prevState) => ({
          attendanceDetails: {
            ...prevState.attendanceDetails,
            activitySlotTempalteId: selectedClassId,
          },
        }),
        () => {
          console.log("class..");
          if (this.state.attendanceDetails.activitySlotTempalteId == -1) {
            //None; Non standard className
            this.initTopics();
          } else {
            //Timetable className
            console.log(
              this.activitySlotTemplates,
              this.state.attendanceDetails.activitySlotTempalteId
            );
            for (let i = 0; i < this.activitySlotTemplates.length; i++) {
              if (
                this.activitySlotTemplates[i].id ==
                this.state.attendanceDetails.activitySlotTempalteId
              ) {
                console.log(
                  "Selected Slot : " +
                    JSON.stringify(this.activitySlotTemplates[i])
                );
                //displaying only Activityslot Topic.
                this.setState(
                  { selectedTopic: this.activitySlotTemplates[i] },
                  () => {
                    this.setState(
                      {
                        topics: [
                          {
                            id: this.state.selectedTopic.topicId,
                            name: this.state.selectedTopic.topicName,
                          },
                        ],
                      },
                      () => {
                        this.setState((prevState) => ({
                          attendanceDetails: {
                            ...prevState.attendanceDetails,
                            topicId: this.state.selectedTopic.id,
                            topicName: this.state.selectedTopic.name,
                            startTime: this.activitySlotTemplates[i].startTime,
                            endTime: this.activitySlotTemplates[i].endTime,
                          },
                        }));
                      }
                    );
                  }
                );
              }
            }
          }
        }
      );
    }
  }

  onTopicChange(topicSelected: any) {
    console.log("On Change Topic : " + JSON.stringify(topicSelected));
    this.setState({ selectedTopic: topicSelected });
    this.setState((prevState) => ({
      attendanceDetails: {
        ...prevState.attendanceDetails,
        topicId: this.state.selectedTopic.id,
        topicName: this.state.selectedTopic.name,
      },
    }));
  }

  initMultipleBatchTopics() {
    const topics = this.state.selectedBatches.reduce(
      (accumulator, currentValue) => [...accumulator, ...currentValue.topics],
      []
    );

    console.log(topics, "heree");
    this.setState({ topics });
    if (topics?.length > 0) {
      const selectedTopic = topics[0];
      this.setState((prevState) => ({
        selectedTopic,
        attendanceDetails: {
          ...prevState.attendanceDetails,
          topicId: selectedTopic.id,
          topicName: selectedTopic.name,
        },
      }));
      //pre-selecting first topic.
    }
  }

  initTopics() {
    const topics = this.state.selectedBatch.topics;
    console.log(topics, "heree");
    this.setState({ topics: this.state.selectedBatch.topics });
    if (topics?.length > 0) {
      const selectedTopic = topics[0];
      this.setState((prevState) => ({
        selectedTopic,
        attendanceDetails: {
          ...prevState.attendanceDetails,
          topicId: selectedTopic.id,
          topicName: selectedTopic.name,
        },
      }));
      //pre-selecting first topic.
    }
  }

  getStudents() {
    const { isUsingCacheMethod } = this.context;
    console.log(
      "In getStudents(), attendanceDetails : " +
        JSON.stringify(this.state.attendanceDetails)
    );
    this.activitySlotId = 0;
    let errorsExists = this.validateAttendanceInput();
    console.log("Error Exits : " + errorsExists);
    this.students = [];
    // Reset attendance already taken flag when fetching new students
    this.setState({ attendanceAlreadyTaken: false });
    if (!errorsExists) {
      console.log("!errorExists...");
      //this.showLoading();
      if (isUsingCacheMethod()) return this.checkAttendnaceAlreadyTaken();
      this.fetchStudentFromApi();
    }
  }

  fetchStudentFromApi = async () => {
    this.setState({ loadingStudents: true });
    if (this.activitySlotStudents.length > 0) {
      console.log(this.activitySlotStudents);
      this.setState({ studentAttendanceDetails: this.activitySlotStudents, loadingStudents: false }); //Update
      if (this.attendanceImages.length > 0) {
        this.setState((preState) => ({
          attendanceImages: [
            ...this.attendanceImages,
            ...preState.attendanceImages,
          ],
        }));
      }
      this.addBioMetricAttendanceStatus();
    } else {
      try {
        // Get templateSlotId from URL query params
        const searchParams = new URLSearchParams(this.props.location.search);
        const templateSlotId = searchParams.get('templateSlotId');
        const templateSlotIdNum = templateSlotId ? parseInt(templateSlotId) : undefined;

        if (this.state.selectedBatches) {
          const res = await Promise.all(
            this.state.selectedBatches.map((selectedBatch) =>
              ApiService.syncStudentsForBatch(selectedBatch.id, templateSlotIdNum)
            )
          );

          console.log(res);

          const students = res.reduce((accumulator, currentValue) => {
            const temp = [...accumulator];

            temp.push(currentValue.data?.data);
            // return [ [...accumulator],[...]]
            return temp;
          }, []);

          console.log(students);

          this.displayMultipleBatchStudents(students);

          return;
        }

        const res = await ApiService.syncStudentsForBatch(
          this.state.selectedBatch.id,
          templateSlotIdNum
        );
        const students = res.data.data;

        this.displayStudents(students);
      } catch (err) {
        console.log(err);
        this.setState({ loadingStudents: false });
      }
    }
  };

  checkAttendnaceAlreadyTaken(): void {
    console.log("In checkAttendnaceAlreadyTaken()...");
    this.activitySlotStudents = [];
    this.ACTIVITYSLOT_ID = -1;
    this.attendanceImages = [];
    AttendanceService.getScheduleActivitySlotsByDate(
      this.state.attendanceDetails.slotDate
    ).then(
      (attendnaceDetails) => {
        console.log(
          "In checkAttendnaceAlreadyTaken()...Length : " +
            attendnaceDetails.length
        );
        if (attendnaceDetails.length > 0) {
          let _noOfTimes: number = 0;
          let _timing: string = "";
          console.log(
            "In checkAttendnaceAlreadyTaken() for loop START.. BatchId : " +
              this.state.attendanceDetails.batchId +
              "; TopicId : " +
              this.state.attendanceDetails.topicId
          );
          attendnaceDetails.forEach((attendanceDetail) => {
            console.log(
              "In checkAttendnaceAlreadyTaken() In for loop.. " +
                attendanceDetail.batchId +
                "==" +
                this.state.attendanceDetails.batchId +
                "; " +
                attendanceDetail.topicId +
                "==" +
                this.state.attendanceDetails.topicId
            );
            if (
              attendanceDetail.batchId ==
                this.state.attendanceDetails.batchId &&
              attendanceDetail.topicId == this.state.attendanceDetails.topicId
            ) {
              console.log("topic & batch are found....");
              if (
                attendanceDetail.startTime ===
                  this.state.attendanceDetails.startTime &&
                attendanceDetail.endTime ===
                  this.state.attendanceDetails.endTime
              ) {
                console.log("Update..");
                //Update
                this.ACTIVITYSLOT_ID = attendanceDetail.id;
                this.activitySlotStudents =
                  attendanceDetail.studentAttendanceDetails;
                this.attendanceImages = attendanceDetail.attendanceImages;
              } else {
                //Attendance already taken for this batch & topic
                _timing +=
                  "(" +
                  attendanceDetail.startTime +
                  " - " +
                  attendanceDetail.endTime +
                  ") ";
                _noOfTimes++;
                console.log("Add.." + _timing);
              }
            }
          });
          console.log("In checkAttendnaceAlreadyTaken() for loop END.. ");
          if (this.ACTIVITYSLOT_ID > 0) {
            let _message =
              "<b>Attendance has been already taken for this Batch/Topic today.</b><br/><b>Are you sure you want to update?</b>";
            this.showAttendanceUpdateConfirm(_message, "Please confirm...");
          } else if (_noOfTimes > 0) {
            let _message =
              "<b>Attendance has been already taken " +
              _noOfTimes +
              " time(s) for this Batch/Topic today " +
              _timing +
              ".</b><br/><b>Are you sure you want to take another attendance?</b>";
            this.showAttendanceUpdateConfirm(_message, "Please confirm...");
          } else {
            this.fetchStudents();
          }
        } else {
          this.fetchStudents();
        }
      },
      (error) => {
        this.showAlertDialog("check Attendnace Already Taken Error:" + error);
        console.log("check Attendnace Already Taken Error:" + error);
      }
    );
  }

  fetchStudents(): void {
    if (this.activitySlotStudents.length > 0) {
      console.log(this.activitySlotStudents);
      this.setState({ studentAttendanceDetails: this.activitySlotStudents }); //Update
      if (this.attendanceImages.length > 0) {
        this.setState((preState) => ({
          attendanceImages: [
            ...this.attendanceImages,
            ...preState.attendanceImages,
          ],
        }));
      }
      this.addBioMetricAttendanceStatus();
    } else {
      this.studentservice.getStudentsForBatch(this.state.selectedBatch.id).then(
        (students) => {
          this.displayStudents(students);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }

  displayMultipleBatchStudents(studentBatches: Array<Student[]>) {
    console.log("In displayStudents()....");
    console.log(studentBatches);
    const studentBatchDetails = [];
    let anyAttendanceTaken = false;

    studentBatches.forEach((batch) => {
      let _studentAttendanceDetails: StudentAttendanceDetail[] = [];
      batch.forEach((student: any) => {
        // Use saved attendance if available, otherwise default to present (true)
        // attendance: 0 = Present, 1 = Absent from Java API
        const attendanceStatus = student.hasAttendance !== undefined
          ? (student.attendance === 0) // 0 = Present
          : true; // Default to present if no saved attendance

        // Check if any student has attendance already taken
        if (student.hasAttendance !== undefined) {
          anyAttendanceTaken = true;
        }

        let studentAttendanceDetail: StudentAttendanceDetail = {
          student: student,
          attendanceStatus: attendanceStatus,
          bioMetricAttendnace: null,
        };
        console.log("Student: " + studentAttendanceDetail);
        _studentAttendanceDetails.push(studentAttendanceDetail);
      });
      studentBatchDetails.push(_studentAttendanceDetails);
    });
    // console.log(_studentAttendanceDetails);
    this.setState({
      studentAttendanceDetails: studentBatchDetails,
      loadingStudents: false,
      attendanceAlreadyTaken: anyAttendanceTaken
    }, () => {
      console.log("state student details");
      console.log(this.state.studentAttendanceDetails);
      this.addMultipleBatchBioMetricAttendanceStatus();
    });
  }

  displayStudents(students: Student[]) {
    console.log("In displayStudents()....");
    console.log(students);
    let _studentAttendanceDetails: StudentAttendanceDetail[] = [];
    let anyAttendanceTaken = false;

    students.forEach((student: any) => {
      // Use saved attendance if available, otherwise default to present (true)
      // attendance: 0 = Present, 1 = Absent from Java API
      const attendanceStatus = student.hasAttendance !== undefined
        ? (student.attendance === 0) // 0 = Present
        : true; // Default to present if no saved attendance

      // Check if any student has attendance already taken
      if (student.hasAttendance !== undefined) {
        anyAttendanceTaken = true;
      }

      let studentAttendanceDetail: StudentAttendanceDetail = {
        student: student,
        attendanceStatus: attendanceStatus,
        bioMetricAttendnace: null,
      };
      console.log("Student: " + studentAttendanceDetail);
      _studentAttendanceDetails.push(studentAttendanceDetail);
    });
    // console.log(_studentAttendanceDetails);
    this.setState({
      studentAttendanceDetails: _studentAttendanceDetails,
      loadingStudents: false,
      attendanceAlreadyTaken: anyAttendanceTaken
    });
    console.log("state student details");
    console.log(this.state.studentAttendanceDetails);
    this.addBioMetricAttendanceStatus();
  }


  saveAttendanceToNodeApi = async (scheduleActivitySlot: any) => {
    const activityTemplateId = scheduleActivitySlot.activityTemplateId;
    const nodePayload = {
      batchIds: [scheduleActivitySlot.batchId],
      studentAttendanceDetails: scheduleActivitySlot.studentAttendanceDetails,
      startTime: typeof scheduleActivitySlot.startTime === 'string' && scheduleActivitySlot.startTime ? scheduleActivitySlot.startTime : undefined,
      endTime: typeof scheduleActivitySlot.endTime === 'string' && scheduleActivitySlot.endTime ? scheduleActivitySlot.endTime : undefined,
      topicId: scheduleActivitySlot.topicId > 0 ? scheduleActivitySlot.topicId : undefined,
      instructorId: scheduleActivitySlot.instructorId > 0 ? scheduleActivitySlot.instructorId : undefined,
      slotStatus: 'Conducted',
    };
    console.log('Saving attendance via Node:', nodePayload);
    try {
      const res = await ApiService.saveActivitySlotAttendance(activityTemplateId, nodePayload);
      console.log(res);
      let presentCount = 0, absentCount = 0;
      scheduleActivitySlot.studentAttendanceDetails.forEach((d) =>
        d.attendanceStatus ? presentCount++ : absentCount++
      );
      const message = "<b>Attendance saved successfully.</b>"
        + "<br/>Number of Students Present : <b style='color:green'>" + presentCount + "</b>"
        + "<br/>Number of Students Absent : <b style='color:red'>" + absentCount;
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveSuccessAlert(message, scheduleActivitySlot);
    } catch (error) {
      console.log(error);
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveErrorAlert(error);
    }
  };

  saveMultipleAttendanceToNodeApi = async (scheduleActivitySlot: any) => {
    const activityTemplateId = scheduleActivitySlot.activityTemplateId;
    // studentAttendanceDetails is nested: [[batch1Students], [batch2Students]]
    const flatStudents = scheduleActivitySlot.studentAttendanceDetails.flat();
    const nodePayload = {
      batchIds: scheduleActivitySlot.batchIds,
      studentAttendanceDetails: flatStudents,
      startTime: typeof scheduleActivitySlot.startTime === 'string' && scheduleActivitySlot.startTime ? scheduleActivitySlot.startTime : undefined,
      endTime: typeof scheduleActivitySlot.endTime === 'string' && scheduleActivitySlot.endTime ? scheduleActivitySlot.endTime : undefined,
      topicId: scheduleActivitySlot.topicId > 0 ? scheduleActivitySlot.topicId : undefined,
      instructorId: scheduleActivitySlot.instructorId > 0 ? scheduleActivitySlot.instructorId : undefined,
      slotStatus: 'Conducted',
    };
    console.log('Saving multi-batch attendance via Node:', nodePayload);
    try {
      const res = await ApiService.saveActivitySlotAttendance(activityTemplateId, nodePayload);
      console.log(res);
      let presentCount = 0, absentCount = 0;
      flatStudents.forEach((d) => d.attendanceStatus ? presentCount++ : absentCount++);
      const message = "<b>Attendance saved successfully.</b>"
        + "<br/>Number of Students Present : <b style='color:green'>" + presentCount + "</b>"
        + "<br/>Number of Students Absent : <b style='color:red'>" + absentCount;
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveSuccessAlert(message, scheduleActivitySlot);
    } catch (error) {
      console.log(error);
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveErrorAlert(error);
    }
  };

  saveMultipleAttendanceToAPi = async (scheduleActivitySlot)=>{
    // Legacy page → original Java multi-batch sync endpoint (see note in
    // saveAttendanceToAPi). Node save is handled on the /attendance-node page.
    console.log(scheduleActivitySlot, "here");
    const payload = [];
    
    scheduleActivitySlot.batchIds.forEach((batchId, index) => {
      const _attendanceDetails: any = [];
      const currentBathDetails = {...scheduleActivitySlot};
      
      delete currentBathDetails.batchIds;
      
      currentBathDetails.batchId = batchId;
      currentBathDetails.studentAttendanceDetails = currentBathDetails.studentAttendanceDetails[index];
      currentBathDetails.batchName = currentBathDetails.batchName[index];
      
      
      currentBathDetails.studentAttendanceDetails.forEach(
        (attendanceDetail, i) => {
          let studentAttendanceDetail: any = {
            enrollmentId: attendanceDetail.student.enrollmentId,
            attendanceStatusId:
            attendanceDetail.attendanceStatus === true ? 1 : 2, //1= Present; 2= Absent
          };
          _attendanceDetails.push(studentAttendanceDetail);
        }
      );
      currentBathDetails.attendanceDetails = _attendanceDetails;
      const currentUser = AuthenticationService?.currentUserValue;
      // submittedBy must resolve to a real Employee on the Java side (it becomes
      // createdByUser). For admins/staff recording on behalf of an instructor,
      // currentUser.instructorId is null — fall back to the slot/URL instructor
      // (same resolution used elsewhere on this page) so Java doesn't NPE on a
      // null createdByUser.
      currentBathDetails.submittedBy =
        currentUser?.instructorId ||
        currentBathDetails.instructorId ||
        (this as any).urlInstructorId;
      currentBathDetails.classStatus = 1;
      
      payload.push(currentBathDetails);

    });
    
    console.log(payload, "here");

    try {
      const res = await ApiService.syncOutMultipleBatchAttendance(payload);
      console.log(res);
      if (res.data.status === 0) {
        console.log("Save Attendance Error:" + res.data);
        this.setState({ savingAttendance: false });
        return this.showAttendanceSaveErrorAlert(res.data.message);
      }

      this.setState({ savingAttendance: false });
      this.showAttendanceSaveSuccessAlert(res.data.message, scheduleActivitySlot);
    } catch (error) {
      console.log(error);
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveErrorAlert(error);
      console.log("Save Attendance Error:" + error);
    }

  }

  saveAttendanceToAPi = async (scheduleActivitySlot: any) => {
    // This legacy /attendance page always saves through the original Java
    // sync endpoints. The Node save flow lives on the separate /attendance-node
    // page so the two backends stay decoupled and Java behaviour is preserved.
    console.log(scheduleActivitySlot, "here");
    let syncOutAttendanceData: any = scheduleActivitySlot;
    let _attendanceDetails: any = [];

    if(scheduleActivitySlot.batchIds?.length){
      return this.saveMultipleAttendanceToAPi(scheduleActivitySlot);
    }


    scheduleActivitySlot.studentAttendanceDetails.forEach(
      (attendanceDetail, i) => {
          let studentAttendanceDetail: any = {
            enrollmentId: attendanceDetail.student.enrollmentId,
            attendanceStatusId:
              attendanceDetail.attendanceStatus === true ? 1 : 2, //1= Present; 2= Absent
          };
          _attendanceDetails.push(studentAttendanceDetail);
      }
    );
    syncOutAttendanceData.attendanceDetails = _attendanceDetails;
    const currentUser = AuthenticationService?.currentUserValue;
    // submittedBy must resolve to a real Employee on the Java side (it becomes
    // createdByUser). For admins/staff recording on behalf of an instructor,
    // currentUser.instructorId is null — fall back to the slot/URL instructor
    // (same resolution used elsewhere on this page) so Java doesn't NPE on a
    // null createdByUser.
    syncOutAttendanceData.submittedBy =
      currentUser?.instructorId ||
      syncOutAttendanceData.instructorId ||
      (this as any).urlInstructorId;
    syncOutAttendanceData.classStatus = 1;
    console.log("SYNC OUT Data : " + JSON.stringify(syncOutAttendanceData));
    try {
      const res = await ApiService.syncOutAttendnace(syncOutAttendanceData);
      console.log(res);
      if (res.data.status === 0) {
        console.log("Save Attendance Error:" + res.data);
        this.setState({ savingAttendance: false });
        return this.showAttendanceSaveErrorAlert(res.data.message);
      }

      let presentCount = 0;
      let absentCount = 0;
      scheduleActivitySlot.studentAttendanceDetails.forEach(
        (studentAttendanceDetail) => {
          studentAttendanceDetail.attendanceStatus == true
            ? presentCount++
            : absentCount++;
        }
      );
      let message =
        "<b>Attendance saved successfully.</b>" +
        "<br/>Number of Students Present : <b style='color:green'>" +
        presentCount +
        "</b>" +
        "<br/>Number of Students Absent : <b style='color:red'>" +
        absentCount;
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveSuccessAlert(message, scheduleActivitySlot);
    } catch (error) {
      console.log(error);
      this.setState({ savingAttendance: false });
      this.showAttendanceSaveErrorAlert(error);
      console.log("Save Attendance Error:" + error);
    }
  };

  saveAttendace() {
    const { isUsingCacheMethod } = this.context;

    this.setState({ savingAttendance: true });
    console.log("In saveAttendace()....");
    console.log(JSON.stringify(this.state.studentAttendanceDetails));

    let scheduleActivitySlot: any = {
      batchId: this.state.attendanceDetails.batchId,
      batchIds: this.state.attendanceDetails.batchIds,
      batchName: this.state.attendanceDetails.batchName,
      date: this.state.attendanceDetails.slotDate,
      startTime: this.state.attendanceDetails.startTime || "",
      endTime: this.state.attendanceDetails.endTime || "",
      topicId: this.state.attendanceDetails.topicId,
      topicName: this.state.attendanceDetails.topicName,
      minutesLate: this.state.attendanceDetails.minutesLate,
      instructorId: this.state.attendanceDetails.instructorId,
      templateId: this.state.attendanceDetails.timeTableId,
      activityTemplateId: this.state.attendanceDetails.activitySlotTempalteId,
      syncStatus: 0,
      studentAttendanceDetails: this.state.studentAttendanceDetails,
      attendanceImages: this.state.attendanceImages,
    };
    console.log(scheduleActivitySlot);
    if (this.ACTIVITYSLOT_ID > 0) {
      scheduleActivitySlot.id = this.ACTIVITYSLOT_ID;
    }
    console.log("Save Result :" + JSON.stringify(scheduleActivitySlot));

    if (!isUsingCacheMethod())
      return this.saveAttendanceToAPi(scheduleActivitySlot);

    AttendanceService.saveAttendance(scheduleActivitySlot)
      .then(
        (data) => {
          console.log("Attendance save success..");
          let presentCount = 0;
          let absentCount = 0;
          scheduleActivitySlot.studentAttendanceDetails.forEach(
            (studentAttendanceDetail) => {
              studentAttendanceDetail.attendanceStatus == true
                ? presentCount++
                : absentCount++;
            }
          );

          let message =
            "<b>Attendance saved successfully.</b>" +
            "<br/>Number of Students Present : <b style='color:green'>" +
            presentCount +
            "</b>" +
            "<br/>Number of Students Absent : <b style='color:red'>" +
            absentCount;
          this.setState({ savingAttendance: false });
          this.showAttendanceSaveSuccessAlert(message, scheduleActivitySlot);
        },
        (error) => {
          this.setState({ savingAttendance: false });
          this.showAttendanceSaveErrorAlert(error);
          console.log("Save Attendance Error:" + error);
        }
      )
      .catch((e) => { this.setState({ savingAttendance: false }); console.log("error while saving attendance:" + e.message); });
  }

  validateAttendanceInput(): any {
    var isError: any = false;
    this.resetErrorMessages();
    if (this.validateServerDate()) {
      isError = true;
      this.setState({
        showConfirm: true,
        confirmTitle: "DATE ERROR",
        confirmMessage:
          "We suspect your device date is incorrect.\n Please go to device settings and correct it",
      });
      this.showAlertDialog(
        "We suspect your device date is incorrect.\n Please go to device settings and correct it."
      );
    } else {
      if (!this.state.selectedBatch && !this.state.selectedBatches) {
        isError = true;
        this.errorMessages.batchId =
          "*Select " + this.state.ATTENDANCE_CONFIG.batchDisplayName;
        console.log(this.errorMessages.batchId);
      }
      if (
        this.state.attendanceDetails.timeTableId != -100 &&
        this.state.attendanceDetails.activitySlotTempalteId == -1
      ) {
        isError = true;
        this.errorMessages.activitySlotTempalteId =
          "*Select " + this.state.ATTENDANCE_CONFIG.classDisplayName;
        console.log(this.errorMessages.activitySlotTempalteId);
      }
      if (this.state.attendanceDetails.startTime == -1) {
        isError = true;
        this.errorMessages.startTime = "*Select Start Time";
        console.log(this.errorMessages.startTime);
      } else if (this.state.attendanceDetails.endTime == -1) {
        isError = true;
        this.errorMessages.endTime = "*Select End Time";
        console.log(this.errorMessages.endTime);
      }
      if (parseInt(this.state.attendanceDetails.timeTableId) <= 0) {
        if (
          this.state.attendanceDetails.startTime >
          this.state.attendanceDetails.endTime
        ) {
          isError = true;
          this.errorMessages.endTime =
            "*End Time must be greater than Start Time";
          console.log(this.errorMessages.endTime);
        }
      }
      if (
        this.state.attendanceDetails.topicId == "" ||
        this.state.attendanceDetails.topicId == -1
      ) {
        isError = true;
        this.errorMessages.topicId =
          "*Select " + this.state.ATTENDANCE_CONFIG.topicDisplayName;
        console.log(this.errorMessages.topicId);
      }
    }
    return isError;
  }

  resetErrorMessages() {
    this.errorMessages = {
      timeTableId: "",
      activitySlotTempalteId: "",
      startTime: "",
      endTime: "",
      minutesLate: "",
      topicId: "",
    };
  }

  validateServerDate(): any {
    let severDate = this.state.ATTENDANCE_CONFIG.syncDate;
    if (severDate != null) {
      let values = severDate.split("/");
      let today = new Date();
      let _todayDate = new Date(
        today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear()
      );
      let _serverDate = new Date(values[1] + "/" + values[0] + "/" + values[2]);
      console.log(
        "Device Date : " +
          (today.getMonth() + 1) +
          "/" +
          today.getDate() +
          "/" +
          today.getFullYear() +
          " Server Date : " +
          values[1] +
          "/" +
          values[0] +
          "/" +
          values[2]
      );
      if (_todayDate < _serverDate) {
        return true;
      }
    } else return false;
  }

  // showConfirmDialog() {
  //   const result = DialogService.confirm('Please confirm..', 'Do you really want to ... ?')
  //   if(result) console.log('User confirmed:', result)
  //   else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog)')
  // }

  showAlertDialog(message: string) {
    this.setState({ alertMessage: message, showAlert: true });
  }

  showAttendanceUpdateConfirm(message: string, title: string) {
    this.setState({
      showConfirm: true,
      confirmId: 3,
      confirmMessage: message,
      confirmTitle: title,
    });
    // const result = DialogService.confirm(message, title)
    // if(result){
    //   console.log('User confirmed:', result);

    // }
    // else console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog or by clicking cancel)');
  }

  showAttendanceSaveSuccessAlert(message: string, scheduleActivitySlot: any) {
    // const result =  confirmDialog(message,'success','ok','cancel','lg',() => { return true} )
    this.setState({
      showConfirm: true,
      confirmId: 1,
      confirmMessage: message,
      confirmTitle: "ATTENDANCE SAVE SUCCESS",
      selectedScheduleActivitySlot: scheduleActivitySlot,
    });
    // console.log('User confirmed:', result);

    // else  console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog or clicked cancel)')
  }

  displayLessonPlan(scheduleActivitySlot: any) {
    if (
      this.state.ATTENDANCE_CONFIG.showLessonplanAfterAttendance &&
      this.state.ATTENDANCE_CONFIG.showLessonplanAfterAttendance == true
    ) {
      //console.log("Show Lesson plan..");
      this.props.history.replace({
        pathname: "/lessonplan",
        state: scheduleActivitySlot,
      });
    } else {
      this._dismiss();
    }
  }

  handleClick = (flag: boolean) => {
    if (flag) {
      this._dismiss();
    }
    console.log("user confirmed:" + flag);
  };

  showAttendanceSaveErrorAlert(message: any) {
    // Callers pass either a plain string (Java path) or the raw axios error
    // object (Node path). The Node controller returns the real reason and a
    // validation-gate code in response.data — surface that instead of the
    // generic "Request failed with status code 400".
    let resolved: string;
    if (typeof message === "string") {
      resolved = message;
    } else {
      const data = message?.response?.data;
      const backendMsg = data?.message || data?.error;
      const code = data?.code ? ` (${data.code})` : "";
      resolved =
        (backendMsg ? `${backendMsg}${code}` : "") ||
        message?.message ||
        "Failed to save attendance.";
    }
    this.setState({
      showConfirm: true,
      confirmId: 2,
      confirmMessage: resolved,
      confirmTitle: "ATTENDANCE SAVE ERROR",
    });
    // const result = DialogService.confirm(message, "Error")
    // if(result){
    //   console.log('User confirmed:', result);
    //   this._dismiss();
    // }
    // else  console.log('User dismissed the dialog (e.g., by using ESC, clicking the cross icon, or clicking outside the dialog or clicked cancel)')
  }

  _dismiss() {
    this.props.history.goBack();
  }

  closeBatchPicker() {
    this.setState({ batchPickerSlotFlag: false });
  }

  handleAttendanceSwitch(status, index, studentIndex = null) {
    let studentDetails = this.state.studentAttendanceDetails;
    // console.log(typeof studentDetails)

    if(studentIndex !== null){
      studentDetails[index][studentIndex].attendanceStatus = status ? false : true;
    }else{
      
      studentDetails[index].attendanceStatus = status ? false : true;
    }

    // student.attendanceStatus = (status)?false:true
    this.setState({ studentAttendanceDetails: studentDetails });
  }

  handleAllPresent() {
    let studentDetails = this.state.studentAttendanceDetails;
    studentDetails.map((s, i) => {
      if (Array.isArray(s)) {
        s.forEach((student) => {
          student.attendanceStatus = true;
        });
      } else {
        s.attendanceStatus = true;
      }
    });
    this.setState({ studentAttendanceDetails: studentDetails });
  }

  handleAllAbsent() {
    let studentDetails = this.state.studentAttendanceDetails;
    studentDetails.map((s) => {
      if (Array.isArray(s)) {
        s.forEach((student) => {
          student.attendanceStatus = false;
        });
      } else {
        s.attendanceStatus = false;
      }
    });
    this.setState({ studentAttendanceDetails: studentDetails });
  }

  handleConfirm(flag) {
    this.setState({ showConfirm: false });
    if (this.state.confirmId === 1) {
      if (flag) {
        delete this.state.selectedScheduleActivitySlot.studentAttendanceDetails;
        this.setState((prevState) => ({
          attendanceDetails: {
            ...prevState.attendanceDetails,
            topicId: this.state.selectedTopic.id,
            topicName: this.state.selectedTopic.name,
          },
        }));
        this.setState((prevState) => ({
          selectedScheduleActivitySlot: {
            ...prevState.selectedScheduleActivitySlot,
            batchName: this.state.selectedBatch.name,
            topicName: this.state.selectedTopic.name,
          },
        }));
        // scheduleActivitySlot.topicName = this.state.selectedTopic.name;
        this.displayLessonPlan(this.state.selectedScheduleActivitySlot);
      }
    } else if (this.state.confirmId === 2) {
      this._dismiss();
    } else if (this.state.confirmId === 3) {
      if (flag) {
        this.fetchStudents();
      }
    }
  }

  handleAlert = (flag) => {
    this.setState({ showAlert: false });
    if (flag) console.log("user clicked ok to the alert message");
    else console.log("User dismissed the alert dialog");
  }

  deleteCapturedImage = (id) => {
    let holdingArray = this.state.attendanceImages;
    holdingArray.splice(id, 1);
    this.setState({ attendanceImages: [...holdingArray] });
  };

  openImagePreview = () => {
    this.setState({ displayImagePreview: true });
  };

  closeImagePreview = () => {
    this.setState({ displayImagePreview: false });
  };

  openCamera = () => {
    // send attendace detail here
    this.props.history.push({
      pathname: "/camera",
      state: {
        selectedBatch: this.state.selectedBatch,
        attendanceImages: this.state.attendanceImages,
        studentAttendanceDetails: this.state.studentAttendanceDetails,
      },
    });
  };

  render() {
    return (
      <div className="attendance">
        {this.state.showAlert && (
          <AlertDialog
            message={this.state.alertMessage}
            title={this.state.alertTitle}
            btnOkText={this.state.btnOkText}
            size="lg"
            close={this.handleAlert}
          />
        )}
        {this.state.showConfirm && (
          <ConfirmDialog
            message={this.state.confirmMessage}
            title={this.state.confirmTitle}
            btnOkText={this.state.btnOkText}
            btnCancelText={this.state.btnCancelText}
            handleResult={this.handleConfirm}
            size={this.state.confirmSize}
          />
        )}
        <div className="app flex-row align-items-center">
          <div className="container">
            <div className="card-group">
              <div className="card text-center border-info full-height1">
                <div className="card-header pageheading bg-info text-white">
                  <FontAwesomeIcon
                    icon={faArrowLeft}
                    size="lg"
                    className="float-left"
                    onClick={() => this._dismiss()}
                  ></FontAwesomeIcon>
                  <b>Attendance</b>
                  <CameraIcon
                    onClick={this.openCamera}
                    className="float-right attendance-camera-icon"
                  />
                </div>
                <div className="card-body">
                  {this.state.batchPickerSlotFlag && (
                    <ModalBatchPicker
                      my_modal_title="Batch Picker"
                      batches={this.state.batches}
                      my_modal_content=" "
                      getResult={this.getSelectedBatch}
                      close={this.closeBatchPicker}
                    ></ModalBatchPicker>
                  )}
                  <div className="row" onClick={this.openBatchPicker}>
                    <div className="col text-left">
                      <h5>
                        {this.state.selectedBatch
                          ? this.state.selectedBatch.name
                          : this.state.selectedBatches
                          ? this.state.selectedBatches
                              .map((selectedBatch) => selectedBatch.name)
                              .join(",")
                          : "--Select " +
                            this.state.ATTENDANCE_CONFIG.batchDisplayName +
                            "--"}
                      </h5>
                    </div>
                    {this.errorMessages.batchId &&
                      this.errorMessages.batchId.length > 0 && (
                        <div className="text-danger">
                          {this.errorMessages.batchId}
                        </div>
                      )}
                  </div>
                  {this.state.instructors.length > 0 && (
                    <div className="row">
                      <div className="col col-5 text-left">
                        <label className="my-label">Instructor</label>
                      </div>
                      <div className="col text-right">
                        <select
                          className="form-control"
                          value={this.state.selectedInstructorId}
                          onChange={(e) => this.onInstructorChange(parseInt(e.target.value))}
                        >
                          {this.state.instructors.map((inst, idx) => (
                            <option key={idx} value={inst.id}>
                              {inst.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                  <div className="row">
                    <div className="col col-5 text-left">
                      <label className="my-label">Timetable</label>
                    </div>
                    <div className="col text-right">
                      <select
                        className="form-control"
                        // [(ngModel)]="attendanceDetails.timeTableId"
                        onChange={() => this.onSelectChange("timetable")}
                      >
                        {this.state.timetableTemplates?.map(
                          (timeTable, idx) => (
                            <option
                              value={timeTable.id}
                              selected={
                                this.state.attendanceDetails.timeTableId ===
                                timeTable.id
                              }
                              key={idx}
                            >
                              {timeTable.name}
                            </option>
                          )
                        )}
                        <option
                          value="-100"
                          selected={
                            this.state.attendanceDetails.timeTableId === -100
                          }
                        >
                          Non Standard
                        </option>
                      </select>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col col-5 text-left">
                      <label className="my-label">
                        {this.state.ATTENDANCE_CONFIG.classDisplayName}
                      </label>
                    </div>
                    <div className="col text-right">
                      <select
                        className="form-control"
                        // [(ngModel)]="attendanceDetails.activitySlotTempalteId"
                        onChange={(e) => {
                          this.onSelectChange("class", e.target.value);
                        }}
                      >
                        {this.activitySlotTemplates?.map(
                          (activitySlotTemplate, idx) => (
                            <option
                              key={idx}
                              value={activitySlotTemplate.id}
                              selected={
                                this.state.attendanceDetails
                                  .activitySlotTempalteId ==
                                activitySlotTemplate.id
                              }
                            >
                              {activitySlotTemplate.topicName}
                            </option>
                          )
                        )}
                        {(this.activitySlotTemplates.length == 0 ||
                          this.state.attendanceDetails.activitySlotTempalteId ==
                            -1) && (
                          <option
                            selected={
                              this.state.attendanceDetails
                                .activitySlotTempalteId == -1
                            }
                          >
                            #None
                          </option>
                        )}
                      </select>
                    </div>
                    {this.errorMessages.activitySlotTempalteId &&
                      this.errorMessages.activitySlotTempalteId.length > 0 && (
                        <div className="text-danger">
                          {this.errorMessages.activitySlotTempalteId}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div className="col col-5 text-left">
                      <label className="my-label">Start Time</label>
                    </div>
                    {this.state.startTimePickerFlag && (
                      <ModalAttendanceTimePicker
                        my_modal_title="Attendance Start Time Picker"
                        minuteStep={5}
                        getStartTime={this.getStartTime}
                        close={this.closeStartTimePicker}
                      ></ModalAttendanceTimePicker>
                    )}
                    <div
                      className="col text-right my-label"
                      onClick={() => this.displayStartTimePicker()}
                    >
                      {this.state.attendanceDetails.startTime}
                    </div>
                    {this.errorMessages.startTime &&
                      this.errorMessages.startTime.length > 0 && (
                        <div className="text-danger">
                          {this.errorMessages.startTime}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div className="col col-5 text-left ">
                      <label className="my-label">End Time</label>
                    </div>
                    {this.state.endTimePickerFlag && (
                      <ModalAttendanceTimePicker
                        my_modal_title="Attendance End Time Picker"
                        minuteStep={5}
                        getStartTime={this.getEndTime}
                        close={this.closeEndTimePicker}
                      ></ModalAttendanceTimePicker>
                    )}
                    <div
                      className="col text-right my-label"
                      onClick={() => this.displayEndTimePicker()}
                    >
                      {this.state.attendanceDetails.endTime}
                    </div>
                    {this.errorMessages.endTime &&
                      this.errorMessages.endTime.length > 0 && (
                        <div className="text-danger">
                          {this.errorMessages.endTime}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div className="col col-5 text-left ">
                      <label className="my-label">Minutes Late</label>
                    </div>
                    <div className="col text-right">
                      <input
                        className="form-control"
                        type="number"
                        // [(ngModel)]="attendanceDetails.minutesLate"
                        placeholder="Minutes Late"
                      />
                    </div>
                    {this.errorMessages.minutesLate &&
                      this.errorMessages.minutesLate.length > 0 && (
                        <div className="text-danger">
                          {this.errorMessages.minutesLate}
                        </div>
                      )}
                  </div>
                  <div className="row">
                    <div className="col col-5 text-left">
                      <label className="my-label">
                        {this.state.ATTENDANCE_CONFIG.topicDisplayName}
                      </label>
                    </div>
                    <div className="col text-right">
                      <select
                        className="form-control"
                        // [(ngModel)]="attendanceDetails.topicId"
                      >
                        {this.state.topics?.length > 0 &&
                          this.state.topics?.map((topic, idx) => (
                            <option
                              value={topic.id}
                              selected={
                                topic.id == this.state.selectedTopic?.topicId
                              }
                              onSelect={() => this.onTopicChange(topic)}
                              key={idx}
                            >
                              {topic.name}
                            </option>
                          ))}
                        {(this.state.topics == null ||
                          this.state.topics.length <= 0) && (
                          <option
                            value="-1"
                            selected={
                              this.state.attendanceDetails.topicId === -1
                            }
                          >
                            {" "}
                            #None
                          </option>
                        )}
                      </select>
                    </div>
                    {this.errorMessages.topicId &&
                      this.errorMessages.topicId.length > 0 && (
                        <div className="text-danger">
                          {this.errorMessages.topicId}
                        </div>
                      )}
                  </div>
                  {this.state.attendanceImages.length > 0 ? (
                    <div className="attendance-image-div">
                      <img
                        className="attendance-image"
                        src={this.state.attendanceImages[0]}
                        alt="attendanceImage"
                      />
                      <div
                        onClick={this.openImagePreview}
                        className="open-attendance-image"
                      >
                        <ShowImageIcon />
                        <p>Click to open Image</p>
                      </div>
                    </div>
                  ) : null}
                  {this.state.displayImagePreview ? (
                    <ImagePreview
                      deleteCapturedImage={this.deleteCapturedImage}
                      attendanceImages={this.state.attendanceImages}
                      closeImagePreview={this.closeImagePreview}
                    />
                  ) : null}
                  <div className="row">
                    <button
                      type="button"
                      className="btn btn-primary btn-lg btn-block"
                      onClick={() => this.getStudents()}
                      disabled={this.state.loadingStudents}
                    >
                      {this.state.loadingStudents ? 'Loading Students...' : 'Get Students'}
                    </button>
                  </div>

                  {this.state.loadingStudents && (
                    <div className="skeleton-loader-container">
                      {[1, 2, 3, 4, 5, 6].map((i) => (
                        <div key={i} className="skeleton-student-row">
                          <div className="skeleton-switch" />
                          <div className="skeleton-student-info">
                            <div className="skeleton-line skeleton-code" />
                            <div className="skeleton-line skeleton-name" />
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {this.state.attendanceAlreadyTaken && this.state.studentAttendanceDetails?.length > 0 && (
                    <div style={{
                      backgroundColor: 'var(--status-warning-bg)',
                      border: '1px solid var(--status-warning)',
                      borderLeft: '4px solid var(--status-warning)',
                      borderRadius: '4px',
                      padding: '12px 16px',
                      marginTop: '16px',
                      marginBottom: '16px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px'
                    }}>
                      <span style={{ fontSize: '20px' }}>ℹ️</span>
                      <div>
                        <div style={{ fontWeight: 600, color: 'var(--status-warning-text)', marginBottom: '4px' }}>
                          Attendance Already Taken
                        </div>
                        <div style={{ fontSize: '14px', color: 'var(--status-warning-text)' }}>
                          Attendance has already been recorded for this slot. You can modify and save to update the existing attendance.
                        </div>
                      </div>
                    </div>
                  )}

                  {!this.state.loadingStudents && this.state.studentAttendanceDetails?.length > 0 && (
                    <div style={{ display: 'flex', gap: '10px', padding: '10px 0', marginBottom: '10px' }}>
                      <button
                        type="button"
                        style={{ flex: 1, backgroundColor: 'var(--status-success)', color: 'var(--text-on-brand)', border: 'none', borderRadius: '4px', padding: '10px 16px', fontSize: '16px', fontWeight: 500, cursor: 'pointer' }}
                        onClick={() => this.handleAllPresent()}
                      >
                        Mark All Present
                      </button>
                      <button
                        type="button"
                        style={{ flex: 1, backgroundColor: 'var(--status-danger)', color: 'var(--text-on-brand)', border: 'none', borderRadius: '4px', padding: '10px 16px', fontSize: '16px', fontWeight: 500, cursor: 'pointer' }}
                        onClick={() => this.handleAllAbsent()}
                      >
                        Mark All Absent
                      </button>
                    </div>
                  )}
                  <br />
                  {
                    this.state.studentAttendanceDetails?.map(
                      (attendanceDetail, i) => {
                        return Array.isArray(attendanceDetail) ? (
                          <React.Fragment key={`batch-${i}`}>
                            <div style={{
                              padding: '8px 12px',
                              marginTop: i > 0 ? '16px' : '0',
                              marginBottom: '8px',
                              fontWeight: 600,
                              fontSize: '14px',
                              color: 'var(--text-body)',
                              borderBottom: '2px solid var(--border-default)',
                            }}>
                              {this.state.attendanceDetails.batchName?.[i] || `Batch ${i + 1}`}
                            </div>
                          {attendanceDetail.map((studentDetails, j) => (
                            <div key={j}>
                              <div className="row">
                                <div className="col col-auto align-self-center align-items-center">
                                  <label>
                                    <Switch
                                      // [(ngModel)]="attendanceDetail.attendanceStatus"
                                      // onColor="#"
                                      checkedIcon={true}
                                      uncheckedIcon={true}
                                      // aria-labelledby="neat-label"
                                      className="react-switch"
                                      checked={studentDetails.attendanceStatus}
                                      onChange={() => {
                                        this.handleAttendanceSwitch(
                                          studentDetails.attendanceStatus,
                                          i,
                                          j
                                        );
                                      }}
                                    ></Switch>
                                  </label>
                                </div>
                                <div className="col text-left align-self-center align-items-center">
                                  <span>
                                    {studentDetails.student.studentCode}
                                    <br />
                                    {studentDetails.student.name}
                                  </span>
                                  {(studentDetails.bioMetricAttendnace ===
                                    null ||
                                    studentDetails.bioMetricAttendnace ===
                                      undefined) && (
                                    <FontAwesomeIcon
                                      icon={faFingerprint}
                                      size="lg"
                                      className="float-right text-muted"
                                    ></FontAwesomeIcon>
                                  )}
                                  {studentDetails.bioMetricAttendnace !==
                                    null &&
                                    studentDetails.bioMetricAttendnace ===
                                      true && (
                                      <FontAwesomeIcon
                                        icon={faFingerprint}
                                        size="lg"
                                        className="float-right text-secondary"
                                      ></FontAwesomeIcon>
                                    )}
                                  {studentDetails.bioMetricAttendnace !==
                                    null &&
                                    studentDetails.bioMetricAttendnace ===
                                      false && (
                                      <FontAwesomeIcon
                                        icon={faFingerprint}
                                        size="lg"
                                        className="float-right text-danger"
                                      ></FontAwesomeIcon>
                                    )}
                                </div>
                              </div>
                            </div>
                          ))}
                          </React.Fragment>
                        ) : (
                          <div key={i}>
                            <div className="row">
                              <div className="col col-auto align-self-center align-items-center">
                                <label>
                                  <Switch
                                    // [(ngModel)]="attendanceDetail.attendanceStatus"
                                    // onColor="#"
                                    checkedIcon={true}
                                    uncheckedIcon={true}
                                    // aria-labelledby="neat-label"
                                    className="react-switch"
                                    checked={attendanceDetail.attendanceStatus}
                                    onChange={() => {
                                      this.handleAttendanceSwitch(
                                        attendanceDetail.attendanceStatus,
                                        i
                                      );
                                    }}
                                  ></Switch>
                                </label>
                              </div>
                              <div className="col text-left align-self-center align-items-center">
                                <span>
                                  {attendanceDetail.student.studentCode}
                                  <br />
                                  {attendanceDetail.student.name}
                                </span>
                                {(attendanceDetail.bioMetricAttendnace ===
                                  null ||
                                  attendanceDetail.bioMetricAttendnace ===
                                    undefined) && (
                                  <FontAwesomeIcon
                                    icon={faFingerprint}
                                    size="lg"
                                    className="float-right text-muted"
                                  ></FontAwesomeIcon>
                                )}
                                {attendanceDetail.bioMetricAttendnace !==
                                  null &&
                                  attendanceDetail.bioMetricAttendnace ===
                                    true && (
                                    <FontAwesomeIcon
                                      icon={faFingerprint}
                                      size="lg"
                                      className="float-right text-secondary"
                                    ></FontAwesomeIcon>
                                  )}
                                {attendanceDetail.bioMetricAttendnace !==
                                  null &&
                                  attendanceDetail.bioMetricAttendnace ===
                                    false && (
                                    <FontAwesomeIcon
                                      icon={faFingerprint}
                                      size="lg"
                                      className="float-right text-danger"
                                    ></FontAwesomeIcon>
                                  )}
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )
                    // <div className="row" >
                    // <button type="button" className="btn btn-primary btn-lg btn-block" onClick={() => this.saveAttendace()}>SAVE ATTENDANCE</button>
                    // </div>
                  }
                  {this.state.studentAttendanceDetails?.length > 0 && (
                    <div className="row">
                      <button
                        type="button"
                        className={`btn btn-lg btn-block ${this.state.savingAttendance ? 'btn-secondary' : 'btn-primary'}`}
                        onClick={() => this.saveAttendace()}
                        disabled={this.state.savingAttendance}
                      >
                        {this.state.savingAttendance ? (
                          <span>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                            {' '}Saving Attendance...
                          </span>
                        ) : (
                          'SAVE ATTENDANCE'
                        )}
                      </button>
                    </div>
                  )}
                  {/* <div *ngIf="studentAttendanceDetails.length>0">
                        <ng-container *ngFor="let attendanceDetail of studentAttendanceDetails; let i = index;">
                            <!--<li className="list-group-item text-left">{{student.name}}</li>-->
                            <div className="row" >
                                <div className="col col-auto align-self-center align-items-center">
                                    <ui-switch [(ngModel)]="attendanceDetail.attendanceStatus" switchColor="#fcfcfc" checkedLabel="P" uncheckedLabel="A"></ui-switch>
                                </div>
                                <div className="col text-left align-self-center align-items-center">
                                    <span>
                                        {{attendanceDetail.student.studentCode}}<br/>
                                        {{attendanceDetail.student.name}}
                                    </span>
                                    <fa-icon *ngIf="attendanceDetail.bioMetricAttendnace" [icon]="['fas', 'fingerprint']" size="lg" className="float-right" [ngClass]="{'text-success':attendanceDetail.bioMetricAttendnace==='P',
                                    'text-danger':attendanceDetail.bioMetricAttendnace!='P'}"
                                  ></fa-icon>
                                </div>
                                </div>
                            </div>
                        </ng-container>
                                             
                    </div> */}
                </div>
                {/* <!--card-body-end-->                 */}
              </div>
              {/* <!--card-end--> */}
            </div>
            {/* <!--card-group-end--> */}
          </div>
          {/* <!--container-end--> */}
        </div>
      </div>
    );
  }
}
